import APIService from '../api';

export type Broadcast = {
  id: number;
  name: string;
  active: boolean;
};

type PerUserData = {
  email: string;
  data: Record<string, any>;
};

export type TriggerBroadcastRequestData = {
  workspace: string;
  broadcastId: number;
  payload: {
    id_ignore_missing: boolean;
    email_ignore_missing: boolean;
    per_user_data: Array<PerUserData>;
  };
};

export default class CustomerIOService extends APIService {
  host() {
    return process.env.VUE_APP_SERVICES_URL;
  }

  triggerBroadcast(data: TriggerBroadcastRequestData) {
    return this.post('/email/customerio/trigger-broadcast', data);
  }

  listBroadcasts(workspace: string) {
    return this.get<{ broadcasts: Array<Broadcast> }>(
      `/email/customerio/broadcasts/${workspace}`
    );
  }
}
